import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

//静态路由
export const staticRouter = [
  {
    path: '/admin',
    name: 'admin',
    redirect: '/sy',
    meta: {keepAlive:true},
    component: () => import( '@/view/admin'),
    children: [
      {
        path: '/sy',
        name: '首页',
        meta:{
          title:'首页'
        },
        component: () => import('@/view/sy.vue')
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: "登录-注册"
    },
    component: () => import( '@/view/login')
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/home',
    name: 'index',
    meta: {
      title: "首页"
    },
    component: () => import( '@/view/home/index')
  },
  {
    path: '/share/preview',
    name: 'sharePreview',
    meta: {
      title: "文件分享预览"
    },
    component: () => import('@/view/file/sharePreview.vue')
  },
  {
    path: '/file/edit/:fileId',
    name: 'editFile',
    meta: {
      title: "在线编辑"
    },
    component: () => import('@/view/file/editFile.vue')
  },
  {
    path:'*',
    meta: {
      title: "404"
    },
    component: () => import( '@/view/404')
  }
]

const createRouter = () => new Router({
  routes:staticRouter
})

export const router = createRouter()




